"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Aseel_cc_earthing from '../components/Aseel_cc_earthing';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import ccban from '../images/earthing/carbon_coating_cc/carbon_coating_page_banner.jpg';
import ccban_360 from '../images/earthing/carbon_coating_cc/carbon_coating_page_banner_360.jpg';
import ccban_tab from '../images/earthing/carbon_coating_cc/carbon_coating_page_banner_tab.jpg';
import ccban_2x from  '../images/earthing/carbon_coating_cc/carbon_coating_page_banner@2x.jpg';


const CompositecarbonPage = () => {
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Lightning and wind energy landscape with composite carbon coating solution by Ashlok Safe Earthing Electrode Limited" bannertext="" ban1x={ccban} ban2x={ccban_2x} ban360={ccban_360} bantab={ccban_tab}/>
           <ProductsubMenu/>
          <Aseel_cc_earthing/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default CompositecarbonPage
 
